import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import * as ReactBootstrap from "react-bootstrap";
import { useState, useEffect } from "react";
import Title from "../ReusableComponents/title";
import Add from "../../assets/images/addcase.svg";
import { Grid } from "@mui/material";
import "../../assets/css/SupportCenter.scss";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import logoutReducer from "../../store/reducers/logout";
import useMobile from "../../hooks/useMobile";
import { formatDate } from "../../utilities/formatters";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";

const StatFormatter = (data) => {
  const Stat = data && data.toLowerCase();
  const classList =
    Stat === "resolved"
      ? "StatusResolved StatusText"
      : Stat === "dismissed"
      ? "StatusDismissed StatusText"
      : Stat === "in progress"
      ? "StatusProgress StatusText"
      : "status";

  return <div className={`${classList}`}>{data}</div>;
};

const CaseHistoryTable = (props) => {
  const isMobile = useMobile();

  const dispatch = useDispatch();

  const handleChange = (data) => {
    const { showDetails } = props;
    axiosInstance
      .get(`/v2/support/case/history/${data}/`, tokenConfig(myStore.getState))
      .then((res) => {
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(logoutReducer());
          return;
        }

        showDetails(res.data);
        // console.log(res.data.data);
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
          //   console.log(error.response.data)
          //   console.log(error.response.status)
          //   console.log(error.response.headers)
        }
      });
  };

  const [Data, setData] = useState([]);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  useEffect(() => {
    axiosInstance
      .get(`/v2/support/user/cases/get/`, tokenConfig(myStore.getState))
      .then((res) => {
        // console.log("=============================")
        // console.log(res.data.data)
        // console.log("=============================")
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(logoutReducer());
          return;
        }
        setData(
          res.data.data.filter(
            (item) => item.status === "Dismissed" || item.status === "Resolved"
          )
        );
        console.log("Data", Data);
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
        }
      });
  }, []);

  const { handleAdd } = props;
  return (
    <div>
      <Grid
        onClick={() => handleAdd()}
        className="createcase"
        container
        justifyContent="end"
        alignItems="center"
      >
        <img src={Add} alt="" />
        <Title four>Create case</Title>
      </Grid>
      <div className="TableContainer">
        {!isMobile && (
          <ReactBootstrap.Table bordered="true" className="CasesDesk">
            <thead>
              <tr className="d-flex">
                <th>Subject</th>
                <th>Created</th>
                <th>CaseID</th>
                <th>Casetype</th>
                <th>Severity</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(Data).map((data, index) => {
                return (
                  <tr className="d-flex">
                    <td>{Data[data].subject}</td>
                    <td>
                      {Data[data].created && formatDate(Data[data].created)}
                    </td>
                    <td
                      className="CaseIDBox"
                      onClick={() => handleChange(Data[data].id)}
                    >
                      {Data[data].id}
                    </td>
                    <td>{Data[data].Case_Type}</td>
                    <td>{Data[data].severity}</td>
                    <td>{StatFormatter(Data[data].status)}</td>
                  </tr>
                );
              })}
            </tbody>
          </ReactBootstrap.Table>
        )}

        {isMobile && (
          <div className="CasesMobile">
            {Object.keys(Data).map((data, index) => {
              return (
                <div>
                  <div className="CasesBox">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <HeadAndDesc
                          HeadTitle="Subject"
                          SubTitle={Data[data].subject}
                        />
                      </div>
                      <div>{StatFormatter(Data[data].status)}</div>
                    </div>
                    <div>
                      <div className="text-align-left d-flex mbb-10 gapp-20">
                        <div className="d-flex gapp-5 CasesText">
                          <Title three>Case ID: </Title>
                          <Title StyleName="CaseID" four>
                            <span onClick={() => handleChange(Data[data].id)}>
                              {Data[data].id}
                            </span>
                          </Title>
                        </div>
                        <div className="d-flex gapp-5 CasesText">
                          <Title three>Case type : </Title>
                          <Title four>{Data[data].Case_Type}</Title>
                        </div>
                      </div>
                      <div className="d-flex gapp-5 CasesText">
                        <Title three>Date : </Title>
                        <Title four>
                          {Data[data].created && formatDate(Data[data].created)}
                        </Title>
                      </div>
                    </div>
                  </div>

                  {/* <CasesBox
                    Subject={Data[data].subject}
                    Status={StatFormatter(Data[data].status)}
                    CaseID={Data[data].id}
                    Type={Data[data].Case_Type}
                    Date={Data[data].created}
                    onClick={() => handleChange(Data[data].id)}
                /> */}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseHistoryTable;
